import { render, staticRenderFns } from "./edit-card.vue?vue&type=template&id=2721974b&scoped=true"
import script from "./edit-card.vue?vue&type=script&lang=ts"
export * from "./edit-card.vue?vue&type=script&lang=ts"
import style0 from "./edit-card.vue?vue&type=style&index=0&id=2721974b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2721974b",
  null
  
)

export default component.exports